import React from 'react';

import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';

import { Typography, Button } from '@material-ui/core';
import { useQuery, useMutation } from '@apollo/client';
import AddPricesheetDialog from './components/AddPricesheetDialog';
import PricesheetsTable from './components/PricesheetsTable';
import Page from '../page/Page';
import GET_PRICESHEETS from '../../commons/gql/remote/pricesheets/GetPricesheets';
import CREATE_PRICESHEET from '../../commons/gql/remote/pricesheets/CreatePricesheet';
import DELETE_PRICESHEET from '../../commons/gql/remote/pricesheets/DeletePricesheet';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
}));

const PricesheetPage = () => {
  const classes = useStyles();
  const [isPopoverOpen, setPopoverOpen] = React.useState(false);
  const { data: allPricesheets, loading } = useQuery(GET_PRICESHEETS);
  const [createPricesheet] = useMutation(CREATE_PRICESHEET, {
    refetchQueries: [{ query: GET_PRICESHEETS }],
    onCompleted: () => { setPopoverOpen(false); },
  });
  const [deletePricesheet] = useMutation(DELETE_PRICESHEET, {
    refetchQueries: [{ query: GET_PRICESHEETS }],
  });

  if (loading) return <div />;

  return (
    <Page>
      <Typography
        variant="h3"
        className={classes.header}
      >
        Pricesheets
      </Typography>
      <PricesheetsTable
        pricesheets={allPricesheets?.pricesheets}
        onDelete={(pricesheet) => {
          deletePricesheet({
            variables: {
              pricesheetId: pricesheet.id,
            },
          });
        }}
      />
      <Button variant="contained" onClick={() => { setPopoverOpen(true); }}>Add</Button>
      <AddPricesheetDialog
        open={isPopoverOpen}
        onSubmit={(values) => {
          createPricesheet({
            variables: {
              label: values.name,
              baseMarkup: values.baseMarkup,
              scope: values.scope,
              scopeId: values.scopeId,
            },
          });
        }}
      />
    </Page>
  );
};

export default PricesheetPage;
